import React, { FC, useCallback } from 'react';
import { ImageViewerComponentProps } from './types';
import Carousel, { Modal, ModalGateway } from 'react-images';
import { CarouselViewStyle, ModalBlanketStyle, CarouselContainerStyle, CarouselNavButtonStyled } from './styled';
import { Icon, IconSize } from '@bechtel/gds';

const NavigationPrev = (props) => {
  const { getStyles, innerProps } = props;
  return (
    <CarouselNavButtonStyled css={getStyles('navigationPrev', props)} {...innerProps}>
      <Icon icon="chevron-left" fillColor="blue.800" size={IconSize.LARGE}></Icon>
    </CarouselNavButtonStyled>
  );
};

const NavigationNext = (props) => {
  const { getStyles, innerProps } = props;
  return (
    <CarouselNavButtonStyled css={getStyles('navigationNext', props)} {...innerProps}>
      <Icon icon="chevron-right" fillColor="blue.800" size={IconSize.LARGE}></Icon>
    </CarouselNavButtonStyled>
  );
};

export const ImageViewer: FC<ImageViewerComponentProps> = ({
  visible,
  closable,
  onDismiss,
  images,
  selectedImageIndex,
}) => {
  const closeModalClick = useCallback(() => {
    if (closable && onDismiss) {
      onDismiss();
    }
  }, [closable, onDismiss]);

  return (
    <ModalGateway>
      {visible && images && images.length > 0 ? (
        <Modal
          styles={{
            blanket: ModalBlanketStyle,
          }}
          allowFullscreen={false}
          closeOnEsc={true}
          closeOnBackdropClick={true}
          onClose={closeModalClick}
        >
          <Carousel
            components={{ Footer: undefined, Header: undefined, NavigationPrev, NavigationNext }}
            currentIndex={selectedImageIndex > -1 && selectedImageIndex < images.length ? selectedImageIndex : 0}
            views={images.map((x) => ({
              source: x,
            }))}
            styles={{
              container: CarouselContainerStyle,
              view: CarouselViewStyle,
            }}
          />
        </Modal>
      ) : null}
    </ModalGateway>
  );
};
